
export const getters = {
  isLogin: state => () => !!state.awsToken
}

export const mutations = {}

export const actions = {
  async doLogin () {
  },
  async doSignOut () {
  }
}

export default {
  namespaced: true,
  state: {
    token: null
  },
  getters,
  mutations,
  actions
}
